import { dogSearchingBasket } from 'assets/images';
import { PoweredByCuddles } from 'components/Cuddles/PoweredBy/PoweredByCuddles';
import React from 'react';

import classes from './NotFoundPage.module.scss';

export const NotFoundPage: React.FC = () => {
    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <h1 className={classes.title}>Oops! Page Not Found</h1>
                <p>
                    Oh no! We cannot find the page <br /> you were looking for.
                </p>

                <img src={dogSearchingBasket} alt="Dog not found" />
            </div>

            <div className={classes.footer}>
                <PoweredByCuddles />
            </div>
        </div>
    );
};
